<template>
  <o-dialog
    ref="dialog"
    :title="$t('service.addService')"
    :info="$t('components.serviceCategory.actions.addService.info')"
    :options="[
      { text: $t('general.cancel'), type: 'cancel'},
      { text: $t('general.confirm'), type: 'confirm', callback: confirm, validate: false },
    ]"
    :portal="portal"
  >
    <service-select v-model="service" />
  </o-dialog>
</template>

<script setup lang="ts">
import ServiceSelect from '@/components/service/elements/Select.vue'

interface Props {
  portal?: string
}

interface Emits {
  (e: 'update:loading', value: boolean): void
  (e: 'success'): void
  (e: 'error'): void
}

withDefaults(defineProps<Props>(), {
  portal: undefined,
})

const emit = defineEmits<Emits>()
const { $api, $i18n, $notification } = useNuxtApp()

const dialog = ref<any>()
const serviceCategory = ref<any>(null)
const service = ref<any>(null)

const open = (serviceCategoryArg: any) => {
  serviceCategory.value = serviceCategoryArg
  dialog.value.open()
}

const confirm = async () => {
  emit('update:loading', true)

  try {
    if (service.value) {
      service.value.category = serviceCategory.value
      service.value.idServiceCategory = serviceCategory.value.idServiceCategory
      const response = await $api.service.save(service.value)

      if (response.data) {
        $notification.toast({
          title: $i18n.t('components.serviceCategory.actions.addService.success'),
          text: $i18n.t('components.serviceCategory.actions.addService.successInfo', { name: serviceCategory.value.name }),
          variant: 'success',
        })

        emit('success')
        return true
      }
    }
  } catch (e) {
    $notification.toast({
      title: $i18n.t('components.serviceCategory.actions.addService.error'),
      text: $i18n.t('components.serviceCategory.actions.addService.errorInfo', { name: serviceCategory.value.name }),
      variant: 'danger',
    })

    emit('error')
  } finally {
    service.value = null
    emit('update:loading', false)
  }
}

defineExpose({ open })
</script>
